export default __webpack_public_path__ + "static/media/Hero-OgImage.fd545e6c.svg";